export default __webpack_public_path__ + "static/media/gripe-support3.e973de46.png";